import React from 'react'
import CountdownTimer from './CountdownTimer/CountdownTimer'
import PageFooter from './PageFooter/PageFooter'
import { LandingPageStyle } from './styled'

const LandingPage = () => {
  return (
    <LandingPageStyle>
      <p>Landing Page</p>
      <CountdownTimer />

      <PageFooter title="footer title" />
    </LandingPageStyle>
  )
}

export default LandingPage
